import { useLazyQuery } from "@apollo/client";
import { useState, useEffect } from "react";
import { GET_POS } from "../../graphql/queries/pos/pos.queries";
import { CREATE_PO } from "../../graphql/mutations/pos/pos.mutations";

const DEFAULT_QUERY = {
  customer_id: null,
  sort: "-po_date",
  balance_due: null,
};

const useGetManyPOs = () => {
    const [purchaseOrders, setPurchaseOrders] = useState([]);
    const [customerId, setCustomerId] = useState(null);
    const [getPOQuery, { loading, error, data }] = useLazyQuery(GET_POS, {
      fetchPolicy: "no-cache",
    });
  
    const getPOs = async () => {
      if (!customerId) return; // Prevent fetching without a valid ID
      try {
        const res = await getPOQuery({ variables: { customer_id: customerId } });
        setPurchaseOrders(res?.data?.pos || []); // Return an empty array if no POs found
      } catch (error) {
        console.error(`Error getting purchase orders: ${error?.message}`);
      }
    };
  
    useEffect(() => {
      getPOs();
    }, [customerId]);
  
    return {
      getPOs,
      purchaseOrders,
      setCustomerId,
      loading,
      error,
    };
  };
  
export default useGetManyPOs;
